import ManagePromotion from '../../../views/Personnel/Letter/ManagePromotion.letter.view';

export default ManagePromotion;
